import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Exhibitor, Post } from '@planone/bau365/util-fair-data';
import { BreadcrumbElement } from '@planone/shared/ui-elements';

@Component({
  selector: 'bau365-post-section-header',
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
})
export class SectionPostHeaderComponent {
  @Input() post?: Post;
  @Input() exhibitor?: Exhibitor;
  @Input() breadcrumbElements?: BreadcrumbElement[] | undefined;
  @Input() breadcrumbClickable = true;

  @Output() shareButtonDialogOpen: EventEmitter<Event> = new EventEmitter<Event>();

  trackShareButtonDialogOpened = (event: Event) => this.shareButtonDialogOpen.emit(event);
}
